export class ProjectAssignmentChange {
    id: string;
    manuallyPlanned: boolean;
    [key: string]: any;

    constructor(data: Partial<ProjectAssignmentChange> = {}) {
        this.id = data.id || '';
        this.manuallyPlanned = data.manuallyPlanned || false;
    }
}